import {
  Routes,
  Route,
} from "react-router-dom";
import Home from './page/admin/Home';
import SignIn from './page/membership/SignIn';
import SignOut from './page/membership/SignOut';
import Dashboard from './page/admin/Dashboard';
import ProductItem from './page/product/ProductItem';
import SaleProductWizard from './page/product/SaleProductWizard';
import ProductApproval from './page/product/ProductApproval';
import AssistantChat from './page/assistant/AssistantChat';
import UserManagement from './page/admin/UserManagement';
import BuyerManagement from './page/customer/BuyerManagement';
import BuyerApproval from './page/customer/BuyerApproval';
import BuyerProductPricesManagement from './page/customer/BuyerProductPricesManagement';
import StockManagement from './page/stock/StockManagement';
import AdminBasketManagement from './page/order/AdminBasketManagement';
import AdminOrderManagement from './page/order/AdminOrderManagement';
import WareHouseOrderManagement from './page/order/WarehouseOrderManagement';
import ShipmentOrderManagement from './page/shipment/ShipmentOrderManagement';
import ShipmentManagement from './page/shipment/ShipmentManagement';
import WareHouseShipmentManagement from './page/shipment/WareHouseShipmentManagement';
import ShipmentHistory from './page/shipment/ShipmentHistory';
import BuyerFinanceManagement from './page/accounting/BuyerFinanceManagement';
import SaleProductBasketOrder from './page/order/SaleProductBasketOrder';
import StockImportExportManagement from './page/stock/StockImportExportManagement';
import StockImportExportPersonal from './page/stock/StockImportExportPersonal';
import WarehouseManagement from './page/warehouse/WarehouseManagement';
import VehicleManagement from './page/shipment/VehicleManagement';
import VehicleDriversManagement from './page/shipment/VehicleDriversManagement';
import BuyerWarehouseManagement from './page/customer/BuyerWarehouseManagement';
import StockHistory from './page/stock/StockHistory';
import MilkVehicleManagement from './page/production/MilkVehicleManagement'
import MilkVehicleDriverManagement from './page/production/MilkVehicleDriverManagement'
import MilkEntry from './page/production/MilkEntry'
import SalesWaybills from './page/order/SalesWayBills';

function RouterTemplate() {
  return (
        <Routes>
          <Route path="/" element = { <Home/>}/>
          <Route path="sign-in" element = { <SignIn/>}/>
          <Route path="portal-giris" element = { <SignIn/>}/>
          <Route path="sign-out" element = { <SignOut/>}/>
          <Route path="cikis" element = { <SignOut/>}/>
          <Route path="user-management" element = { <UserManagement/>}/>
          <Route path="kullanici-yonetimi" element = { <UserManagement/>}/>
          <Route path="buyer-management" element = { <BuyerManagement/>}/>
          <Route path="buyer-product-prices-management" element = { <BuyerProductPricesManagement/>}/>
          <Route path="buyer-warehouse-management" element = { <BuyerWarehouseManagement/>}/>
          <Route path="musteri-yonetimi" element = { <BuyerManagement/>}/>
          <Route path="buyer-approval" element = { <BuyerApproval/>}/>
          <Route path="dashboard" element = { <Dashboard/>}/>
          <Route path="product-item" element = { <ProductItem/>}/>
          <Route path="stok-yonetimi" element = { <StockManagement/>}/>
          <Route path="mal-giris-cikis-yonetimi" element = { <StockImportExportManagement/>}/>
          <Route path="mal-giris-cikis-yonetimi-2" element = { <StockImportExportPersonal/>}/>
          <Route path="satis-urun-yonetimi" element = { <SaleProductWizard/>}/>
          <Route path="onay-bekleyen-urunler" element = { <ProductApproval/>}/>
          <Route path="siparis-sepeti-olusturma" element = { <SaleProductBasketOrder/>}/>
          <Route path="siparis-sepetleri" element = { <AdminBasketManagement/>}/>
          <Route path="siparisler" element = { <AdminOrderManagement/>}/>
          <Route path="satis-irsaliyeleri" element = { <SalesWaybills/>}/>
          <Route path="depo-siparis-yonetimi" element = { <WareHouseOrderManagement/>}/>
          <Route path="depo-sevkiyat-yonetimi" element = { <WareHouseShipmentManagement/>}/>
          <Route path="sevkiyat-gecmisi" element = { <ShipmentHistory/>}/>
          <Route path="sevkiyat-siparis-yonetimi" element = { <ShipmentOrderManagement/>}/>
          <Route path="sevkiyat-yonetimi" element = { <ShipmentManagement/>}/>
          <Route path="musteri-finans-yonetimi" element = { <BuyerFinanceManagement/>}/>
          <Route path="depo-yonetimi" element={<WarehouseManagement/>} />
          <Route path="stok-gecmisi" element={<StockHistory/>} />
          <Route path="arac-yonetimi" element={<VehicleManagement/>} />
          <Route path="sofor-yonetimi" element={<VehicleDriversManagement/>}/>
          <Route path="sut-araci-yonetimi" element={<MilkVehicleManagement/>}/>
          <Route path="sut-araci-sofor-yonetimi" element={<MilkVehicleDriverManagement/>}/>
          <Route path="sut-girisi" element={<MilkEntry/>}/>
          <Route path="asistan" element={<AssistantChat/>}/>
          <Route path="assistant" element={<AssistantChat/>}/>
        </Routes>
  );
}

export default RouterTemplate;